
/**
 * 메시지 역할
 */
export type ChatStreamBodyMessagesItemRole = typeof ChatStreamBodyMessagesItemRole[keyof typeof ChatStreamBodyMessagesItemRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatStreamBodyMessagesItemRole = {
  user: 'user',
  assistant: 'assistant',
  system: 'system',
} as const;
